import React from 'react';
import { Link } from 'react-router-dom';
import { X, Phone, Tag } from 'lucide-react';
import { getSeasonalSpecial } from '../../data/specials';

export const SeasonalOfferBanner = ({ season, seasonCfg }) => {
  const special = getSeasonalSpecial(season);
  const key = special ? `offer-banner-dismissed-${special.slug}` : null;
  const [dismissed, setDismissed] = React.useState(() => key && sessionStorage.getItem(key) === '1');

  if (!special || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem(key, '1');
    setDismissed(true);
  };

  return (
    <section className={`bg-gradient-to-r ${seasonCfg.colors.gradient} text-white animate-fade-up`} data-testid="seasonal-offer-banner">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <span className="shrink-0 w-10 h-10 rounded-full bg-white/20 flex items-center justify-center"><Tag size={18} /></span>
          <div className="min-w-0">
            <p className="text-xs font-bold uppercase tracking-wider text-white/80">{seasonCfg.name} Special · {special.badge}</p>
            <p className="font-heading font-bold text-xl leading-tight" data-testid="seasonal-offer-title">{special.title}</p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Link to={`/specials/${special.slug}`} className="bg-white text-slate-900 font-bold text-sm px-4 py-2 rounded-full hover:bg-slate-900 hover:text-white transition-colors" data-testid="seasonal-offer-claim-btn">
            Claim Offer
          </Link>
          <a href="tel:8593576803" className="inline-flex items-center gap-1 border border-white/50 font-bold text-sm px-4 py-2 rounded-full hover:bg-white/20 transition-colors" data-testid="seasonal-offer-call-btn">
            <Phone size={14} /> Call
          </a>
          <button onClick={dismiss} aria-label="Dismiss offer" className="p-2 rounded-full hover:bg-white/20 transition-colors" data-testid="seasonal-offer-dismiss-btn">
            <X size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};
